import { useQuery } from "@apollo/client";
import { GET_DYNAMIC_ENUMS_FOR_SELECT } from "../api/get-dynamic-enums-for-select";

export function useDynamicEnumsForSelect() {
  const { data, loading } = useQuery(GET_DYNAMIC_ENUMS_FOR_SELECT);

  const options = (data?.findDynamicEnums.content ?? []).map((item) => ({
    label: item.name.value,
    value: item.id,
  }));

  return {
    options,
    loading,
  };
}
